import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { wrapper, heading, cardsList, card } from './organism.cta.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Card } from './molecule.card/_card.js';
import { ScrambledCard } from './molecule.scrambled-card/_card.js';

function CallToActionComponent(props) {
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, resets.rootCls),
    "data-card-count": props.columnCount ?? Math.min(props.cards.length, 10),
    children: [props.title && /*#__PURE__*/jsx("h2", {
      className: cx(heading, props.isScrambled && "scrambled"),
      children: props.title
    }), /*#__PURE__*/jsx("ul", {
      className: cardsList,
      children: props.cards.map((card$1, index) => /*#__PURE__*/jsx("li", {
        className: card,
        children: !props.isScrambled ? /*#__PURE__*/jsx(Card, {
          card: card$1
        }) : /*#__PURE__*/jsx(ScrambledCard, {})
      }, index))
    })]
  });
}

export { CallToActionComponent };
//# sourceMappingURL=organism.cta.js.map
